import { Icon } from '@aibees/shared/components';
import { InvoiceStatus } from '@aibees/shared/definition';
import { classnames } from '@aibees/shared/utils/class-names';
import { memo } from 'react';
import * as Styled from './styles';
import type { DownloadInvoiceActionProps as Props } from './types';

export const DownloadInvoiceAction = memo(({ className, item }: Props) => {
  if (item.status !== InvoiceStatus.paid) return null;

  return (
    <Styled.Wrapper
      className={classnames('DownloadInvoiceAction', className)}
      to={item.hostedInvoiceUrl}
      target="_blank"
      download
    >
      <Icon name="file-download" /> Download PDF
    </Styled.Wrapper>
  );
});

DownloadInvoiceAction.displayName = 'DownloadInvoiceAction';
